import colors from 'tailwindcss/colors'
import type { DamageState } from '../types/riskProfileSelected.types'

export const CATEGORY_COLOURS: Record<string, string> = {
  Exposed: colors.violet[300],
  Insignificant: colors.rose[200],
  Minor: colors.amber[500],
  Moderate: colors.red[600],
  Major: colors.red[900],
  'Not exposed': colors.stone[400],
}

export const CATEGORY_TEXT_COLOURS: Record<string, string> = {
  Exposed: colors.violet[900],
  Insignificant: colors.red[900],
  Minor: colors.amber[950],
  Moderate: colors.white,
  Major: colors.white,
  'Not exposed': colors.white,
}

export const FALLBACK_COLOUR = '#0ea5e9'

export const PROFILE_RISK_WIDGETS = {
  riskByElementType: {
    groupBy: 'region',
    categoriseBy: 'damage_state',
  },
  riskByElementGroup: {
    groupBy: 'region',
    categoriseBy: 'damage_state',
  },
  riskByHazardType: {
    groupBy: 'region',
    categoriseBy: 'damage_state',
  },
  riskByArea: {
    groupBy: 'region',
    categoriseBy: 'damage_state',
  },
} as const

export const RISK_PROFILE_QUERY_KEY = 'risk-profile'

export const DEFAULT_PROFILE_RISK_PAGINATION = {
  sort_by: 'damage_ratio',
  sort_direction: 'desc',
  page_size: 100,
} as const

export const LOSS_CURVE_COLOUR = '#3BB5CA'
export const LOSS_CURVE_REFERENCE_COLOUR = 'rgba(155, 155, 155, 0.70)'

export const QUADRANT_POINT_COLOUR = LOSS_CURVE_COLOUR
export const QUADRANT_UPPER_LEFT_COLOUR = 'rgba(226, 238, 254, .8)'
export const QUADRANT_UPPER_RIGHT_COLOUR = 'rgba(248, 248, 248, .8)'
export const QUADRANT_LOWER_LEFT_COLOUR = 'rgba(242, 251, 253, .8)'
export const QUADRANT_LOWER_RIGHT_COLOUR = 'rgba(224, 246, 250, .8)'

export type AnalysisMode = 'by-group' | 'by-type'
export const DEFAULT_ANALYSIS_MODE: AnalysisMode = 'by-group'

export type CapitalType = 'built' | 'social' | 'economic'

export const DEFAULT_CAPITAL_TYPE: CapitalType = 'built'

export const SOCIAL_DEMOGRAPHIC_CHART_COLOUR_VARS = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
  'hsl(var(--chart-4))',
  'hsl(var(--chart-5))',
]
export const SOCIAL_ECONOMIC_FALLBACK_CHART_COLOUR = 'hsl(var(--muted-foreground))'

export const TOP_N_AREAS = 10

export const ALL_DAMAGE_STATES_COUNT = 6

export const DAMAGE_STATE_OPTIONS: { value: DamageState; label: string }[] = [
  { value: 'unknown', label: 'Not exposed' },
  { value: 'exposed', label: 'Exposed' },
  { value: 'insignificant', label: 'Insignificant' },
  { value: 'minor', label: 'Minor' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'major', label: 'Major' },
]

export const ALL_DAMAGE_STATE_VALUES = DAMAGE_STATE_OPTIONS.map((option) => option.value)
